import { render, staticRenderFns } from "./TechnicalNotesSection.vue?vue&type=template&id=6885fafe"
import script from "./TechnicalNotesSection.vue?vue&type=script&lang=js"
export * from "./TechnicalNotesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports